// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { ApolloProvider } from "@apollo/client";

import { AuthProvider } from "./contexts/auth";
import DrawerProvider from "./contexts/drawer";
import { IntercomProvider } from "./contexts/intercom";
import { MixpanelProvider } from "./contexts/mixpanel";
import { SnackbarProvider } from "./contexts/snackbar";
import graphql from "./graphql";

export const ApplicationProviders = ({ children }) => {
  const client = graphql.createClient();

  return (
    <ApolloProvider client={client}>
      <SnackbarProvider>
        <AuthProvider>
          <IntercomProvider>
            <MixpanelProvider>
              <DrawerProvider>{children}</DrawerProvider>
            </MixpanelProvider>
          </IntercomProvider>
        </AuthProvider>
      </SnackbarProvider>
    </ApolloProvider>
  );
};
